import { CartLinesUpdateEvent } from '@shopify/events';

// One chooser works across initial cards and dynamically filtered/paginated grids.
const modal = document.createElement('dialog');
modal.className = 'rq-dialog';
modal.setAttribute('aria-labelledby', 'RegimeQuickTitle');
modal.innerHTML = '<button type="button" class="rq-close" aria-label="Close quick shop">×</button><div data-rq-content></div>';
document.body.append(modal);
const content = modal.querySelector('[data-rq-content]');
const toast = document.createElement('div');
toast.className = 'rq-toast'; toast.hidden = true; toast.setAttribute('role', 'status');
document.body.append(toast);
let trigger, mode = 'bag', request, busy = false, toastTimer;
const routeRoot = window.Shopify?.routes?.root || '/';
const cancelPending = () => { request?.abort(); request = null; };
// Dismissal never retries or aborts an in-flight cart POST.
modal.querySelector('.rq-close').addEventListener('click', () => modal.close());
modal.addEventListener('close', () => { cancelPending(); trigger?.focus(); });
const parse = html => new DOMParser().parseFromString(html, 'text/html');
function sync() {
  const panel = content.querySelector('[data-rq-variant]');
  const selects = [...content.querySelectorAll('[data-rq-option]')];
  selects.forEach(select => { select.disabled = busy; });
  content.setAttribute('aria-busy', String(busy));
  const ready = selects.every(select => select.value) && panel?.dataset.variantId && panel.dataset.available === 'true';
  content.querySelector('[data-rq-confirm]').disabled = !ready || busy;
  return ready;
}
async function section(url, signal) {
  const response = await fetch(url, { credentials: 'same-origin', signal });
  if (!response.ok) throw new Error('Unable to load options. Open product details to continue.');
  const product = parse(await response.text()).querySelector('[data-rq-product]');
  if (!product) throw new Error('Unable to load options. Open product details to continue.');
  return product;
}
document.addEventListener('click', async event => {
  const link = event.target.closest?.('[data-rq-open]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
  event.preventDefault(); event.stopPropagation();
  if (busy) return;
  trigger = link; mode = link.dataset.rqOpen; cancelPending(); request = new AbortController();
  content.innerHTML = '<h2 id="RegimeQuickTitle">Make it yours.</h2><p role="status">Loading your options…</p>';
  const fallback = document.createElement('a'); fallback.href = link.href; fallback.textContent = 'Open product details'; content.append(fallback);
  modal.showModal();
  try {
    const url = new URL(link.href); url.searchParams.delete('variant'); url.searchParams.delete('option_values'); url.searchParams.set('section_id','regime-quick-shop');
    const product = await section(url, request.signal);
    if (product.dataset.plans === 'true') { window.location.assign(link.href); return; }
    content.replaceChildren(product);
    content.querySelector('[data-rq-confirm]').textContent = mode === 'buy' ? 'Continue to checkout' : 'Add to bag';
    content.querySelector('[data-rq-checkout-note]').hidden = mode !== 'buy';
    if (product.dataset.single === '1') content.querySelector('[data-rq-status]').textContent = 'A little something for you.';
    sync();
  } catch (error) { if (error.name !== 'AbortError') content.querySelector('[role="status"]').textContent = error.message; }
}, true);
content.addEventListener('change', async event => {
  if (!event.target.matches('[data-rq-option]')) return;
  cancelPending();
  const button = content.querySelector('[data-rq-confirm]'); button.disabled = true;
  const status = content.querySelector('[data-rq-status]');
  const values = [...content.querySelectorAll('[data-rq-option]')].map(select => select.value);
  if (values.some(value => !value)) { status.textContent = 'Choose each option to continue.'; return; }
  request = new AbortController(); status.textContent = 'Checking this combination…';
  try {
    const url = new URL(content.querySelector('[data-rq-product]').dataset.url, location.origin);
    url.searchParams.set('section_id','regime-quick-shop'); url.searchParams.set('option_values',values.join(','));
    const product = await section(url, request.signal);
    content.querySelector('[data-rq-variant]').replaceWith(product.querySelector('[data-rq-variant]'));
    status.textContent = sync() ? 'Your selection is ready.' : 'This combination is unavailable. Try another option.';
  } catch (error) { if (error.name !== 'AbortError') status.textContent = error.message; }
});
content.addEventListener('click', async event => {
  if (!event.target.closest('[data-rq-confirm]') || busy || !sync()) return;
  busy = true; sync();
  const status = content.querySelector('[data-rq-status]'); status.textContent = 'Adding to your bag…';
  const panel = content.querySelector('[data-rq-variant]');
  const id = panel.dataset.variantId, quantity = Number(panel.dataset.quantity) || 1;
  const deferred = CartLinesUpdateEvent.createPromise();
  modal.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:id,quantity}],promise:deferred.promise}));
  let added = false;
  try {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
    const response = await fetch(`${routeRoot}cart/add.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity}],sections,sections_url:location.pathname})});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add this option. Please try another.');
    added = true;
    const cartResponse = await fetch(`${routeRoot}cart.js`, {credentials:'same-origin'});
    if (!cartResponse.ok) throw new Error('Your item was added. Open your bag to review it.');
    const cart = await cartResponse.json();
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'regime-quick-shop',sourceId:'regime-quick-shop',itemCount:quantity,productId:content.querySelector('[data-rq-product]').dataset.productId,sections:result.sections,didError:false}});
    if (mode === 'buy' && modal.open) { window.location.assign(`${routeRoot}checkout`); return; }
    trigger.setAttribute('data-rq-added','true'); trigger.textContent='✓ Added to bag';
    toast.textContent='A lovely choice. Added to your bag.'; toast.hidden=false; clearTimeout(toastTimer); toastTimer=setTimeout(()=>{toast.hidden=true;},4000);
    if (modal.open) modal.close();
  } catch (error) {
    deferred.resolve({detail:{didError:true}});
    status.textContent = added ? 'Your item was added. Open your bag to review it before adding again.' : error.message;
    if (added) { const a = document.createElement('a');a.href=`${routeRoot}cart`;a.textContent='Open your bag';status.append(' ',a); }
    if (!modal.open) { toast.textContent=status.textContent;toast.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>{toast.hidden=true;},8000); }
  } finally { busy=false; content.setAttribute('aria-busy', 'false'); if (!added) sync(); }
});

class RegimeGallery extends HTMLElement {
  connectedCallback() {
    const second=this.querySelector('.re-gallery-second'), controls=this.querySelector('.re-gallery-controls');
    if (!second || !controls || this.ready) return; this.ready=true;
    controls.hidden=false;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');let paused=reduced.matches, hover=false, visible=true, index=0;
    const pause=controls.querySelector('[data-gallery-pause]');
    const paint=()=>{second.hidden=index===0;controls.querySelector('[data-gallery-count]').textContent=`${index+1} / 2`;pause.textContent=paused?'Play':'Pause';pause.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');};
    controls.querySelector('[data-gallery-prev]').onclick=controls.querySelector('[data-gallery-next]').onclick=()=>{index=1-index;paint();};
    pause.onclick=()=>{paused=!paused;paint();};
    this.onmouseenter=()=>{hover=true;};this.onmouseleave=()=>{hover=false;};
    this.observer=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;});this.observer.observe(this);
    this.timer=setInterval(()=>{if(!paused&&!hover&&visible&&!document.hidden&&!this.contains(document.activeElement)){index=1-index;paint();}},7000);
    this.motionHandler=()=>{paused=reduced.matches;paint();};this.motionQuery=reduced;reduced.addEventListener('change',this.motionHandler);paint();
  }
  disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.motionQuery?.removeEventListener('change',this.motionHandler);this.ready=false;}
}
if(!customElements.get('regime-gallery'))customElements.define('regime-gallery',RegimeGallery);

